// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__3DK_S","transactions":"style_transactions__1ltNu","name":"style_name__YsJ30","amount":"style_amount__gCwDv","subtext":"style_subtext__2mUFP"};